var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAlien2 = function SvgAlien2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.536 16.062c.482.497.996.97 1.484 1.462.728.734 1.91 1.726 2.98 1.726s2.252-.992 2.98-1.726c.488-.492 1.002-.965 1.484-1.462C20.266 12.142 17.634 4.75 12 4.75s-8.266 7.391-4.464 11.312ZM10.25 12.25l-1.5-1.5M13.75 12.25l1.5-1.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgAlien2;